(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-singles/assets/javascripts/single-coupon-choice.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-singles/assets/javascripts/single-coupon-choice.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useContext = _React.useContext;
const _svs$components$tipse = svs.components.tipsen.couponId,
  useCouponId = _svs$components$tipse.useCouponId,
  PaymentContext = _svs$components$tipse.PaymentContext;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useIsCouponEmpty = _svs$components$tipse2.useIsCouponEmpty,
  useClearCoupon = _svs$components$tipse2.useClearCoupon;
const CouponToolbox = svs.components.tipsen.routePlaySpela.couponChoice.CouponToolbox;
const _svs$components$tipse3 = svs.components.tipsen.routePlaySpela.couponChoice.constants.showCouponChoice,
  COUPON_CHOICE_NONE = _svs$components$tipse3.COUPON_CHOICE_NONE,
  COUPON_CHOICE_PIX = _svs$components$tipse3.COUPON_CHOICE_PIX;
const SingleCouponXpert = svs.components.tipsen.routePlaySingles.SingleCouponXpert;
const _svs$components$tipse4 = svs.components.tipsen.tipsenModal,
  TipsenModal = _svs$components$tipse4.TipsenModal,
  StickyBottom = _svs$components$tipse4.StickyBottom,
  StickyButtonClose = _svs$components$tipse4.StickyButtonClose;
const _svs$ui = svs.ui,
  ReactIconButton = _svs$ui.ReactIconButton,
  ReactIcon = _svs$ui.ReactIcon;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const ExpandableArea = svs.components.tipsen.expandableArea.ExpandableArea;
const useActionListener = svs.components.tipsen.hooks.useActionListener;
const PixStickyBottom = _ref => {
  let onActivateNone = _ref.onActivateNone;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    onClick: onActivateNone
  }));
};
const SingleCouponChoice = () => {
  const couponId = useCouponId();
  const placeBetAsync = useContext(PaymentContext);
  useActionListener({
    couponId,
    placeBetAsync
  });
  const _useState = useState(COUPON_CHOICE_NONE),
    _useState2 = _slicedToArray(_useState, 2),
    activeChoice = _useState2[0],
    setActiveChoice = _useState2[1];
  const onActivateChoice = useCallback(newActiveChoice => {
    setActiveChoice(oldActiveChoice => {
      if (oldActiveChoice === newActiveChoice) {
        newActiveChoice = COUPON_CHOICE_NONE;
      }
      return newActiveChoice;
    });
  }, [setActiveChoice]);
  const isShowingPix = activeChoice === COUPON_CHOICE_PIX;
  const onActivatePix = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_PIX);
  }, [onActivateChoice]);
  const onActivateNone = useCallback(() => {
    onActivateChoice(COUPON_CHOICE_NONE);
  }, [onActivateChoice]);
  const onClearCoupon = useClearCoupon(couponId);
  const isCouponEmpty = useIsCouponEmpty(couponId);
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const couponToolboxGrid = document.querySelector('.coupon-toolbox');
  let arrowPosition;
  if (couponToolboxGrid) {
    const couponToolboxGridLeftPosition = couponToolboxGrid.getBoundingClientRect().left;
    if (isShowingPix) {
      const pixButton = document.querySelector('.coupon-toolbox-pix-button');
      if (pixButton) {
        const pixRect = pixButton.getBoundingClientRect();
        arrowPosition = pixRect.left + pixRect.width / 2 - couponToolboxGridLeftPosition;
      }
    }
  }
  const idPix = 'expandable-area-singles-pix';
  return React.createElement(React.Fragment, null, React.createElement(CouponToolbox, {
    idPix: idPix,
    isCouponEmpty: isCouponEmpty,
    isShowingPix: isShowingPix,
    onActivateNone: onActivateNone,
    onActivatePix: onActivatePix,
    onClearCoupon: onClearCoupon,
    singleCouponChoice: true
  }), !isExtraSmall && React.createElement(ExpandableArea, {
    arrowPosition: arrowPosition,
    "data-testid": "expandable-area",
    id: idPix,
    isCouponMenu: true,
    isOpen: isShowingPix
  }, isShowingPix && React.createElement(React.Fragment, null, React.createElement(ReactIconButton, {
    className: "xpert-close-btn",
    onClick: onActivateNone
  }, React.createElement(ReactIcon, {
    icon: "close",
    size: "300"
  })), React.createElement(SingleCouponXpert, {
    couponId: couponId
  }))), isExtraSmall && React.createElement(TipsenModal, {
    Bottom: () => React.createElement(PixStickyBottom, {
      onActivateNone: onActivateNone
    }),
    isOpen: isShowingPix
  }, React.createElement("div", {
    className: "margin-left-1-half mobile-modal-view"
  }, React.createElement("div", {
    className: "margin-left-1-half"
  }, React.createElement("div", {
    className: "single-row-xpert-selector-header-container "
  }, React.createElement("div", {
    className: "xpert-selector-header"
  }, "Fyll i med", ' '), React.createElement(ReactIcon, {
    className: "tipsen-mobile-pix-icon",
    icon: "pix",
    size: "600"
  }))), React.createElement("p", {
    className: "margin-h-1 tipsen-mobile-pix-info-text"
  }, "PIX! erbjuder extra hj\xE4lp genom en kombination av experttips och slumpen.")), React.createElement(SingleCouponXpert, {
    couponId: couponId
  })));
};
setGlobal('svs.components.tipsen.routePlaySingles.SingleCouponChoice', SingleCouponChoice);

 })(window);